namespace $.$$ {
	export class $shm_hitalama_mbutton extends $.$shm_hitalama_mbutton {
		
		checked_style() {
			return this.checked() ? {
				outline: '2px solid var(--mol_theme_current)',
				outlineOffset: '2px',
			} : {
				outline: 'none',
			}
		}
		
	}
}
